export enum AUTH_STATE {
  UNAUTHENTICATED,
  AUTHENTICATED,
  LOADING,
}

export enum DEFAULT_BLOCK_TYPE {
  UPCOMING_EVENTS = 'upcoming_events',
  ANNOUNCEMENT = 'announcement',
  CALENDAR = 'calendar',
  BULLETIN = 'bulletin',
  READINGS = 'readings',
  INSPIRE_DAILY = 'inspire_daily',
  PRAYERS = 'prayers',
}

export enum BULLETIN_TYPE {
  DIOCESAN = 'diocesan',
  LPI = 'lpi',
  OTHER = 'other',
  NONE = 'none',
}

export enum BULLETIN_PUBLISH_DAY {
  AUTOMATIC = 'automatic',
  SUNDAY = 'sunday',
  MONDAY = 'monday',
  TUESDAY = 'tuesday',
  WEDNESDAY = 'wednesday',
  THURSDAY = 'thursday',
  FRIDAY = 'friday',
  SATURDAY = 'saturday',
}

export enum CUSTOM_BLOCK_TYPE {
  WEB_LINK = 'web_link',
  RSS_FEED = 'rss_feed',
  VIDEO = 'video',
}

export type BLOCK_TYPE = DEFAULT_BLOCK_TYPE | CUSTOM_BLOCK_TYPE;

export enum BLOCK_VIEW {
  FULL_CONTENT = 'full_content',
  CARD = 'card',
  LIST_WITH_IMAGE = 'list_with_image',
  LIST_WITHOUT_IMAGE = 'list_without_image',
  HIGHLIGHT = 'highlight',
  BANNER = 'banner',
}

export enum LsStoreKey {
  LastSignedUserId = 'lastSignedUserId',
  LastSelectedChurch = 'lastSelectedChurch',
  SelectedCalendar = 'selectedCalendar',
  CalendarSettings = 'calendarSettings',
  LoginChurchId = 'loginChurchId',
  PendingLoginGroupId = 'pendingLoginGroupId',
  MessageCreatorDraft = 'messageCreatorDraft',
  MemberImportBaseline = 'memberImportBaseline',
}

export enum VIEW_TYPE_CARD_BADGE {
  RECOMMENDED = 'recommended',
  REQUIRED = 'required',
}

export enum GROUP_TYPE {
  PUBLIC = 'public',
  PRIVATE = 'private',
  CLOSED = 'closed',
}

export enum GROUP_KIND {
  ALL_MEMBERS = 'all_members',
  BULLETIN = 'bulletin',
  REGULAR = 'regular',
  STAFF = 'staff',
  SCHOOL_STAFF = 'school_staff',
}

export enum VIEW_TYPE {
  DESKTOP = 'desktop',
  MOBILE = 'mobile',
  ADAPTIVE = 'adaptive',
}

export enum MEMBER_SORT_FIELD {
  FIRST_NAME = 'first_name',
  LAST_NAME = 'last_name',
  EMAIL = 'email',
  PHONE = 'phone',
  CREATED_DATE = 'created_date',
}

export enum CHURCH_ADMIN_SORT_FIELD {
  FIRST_NAME = 'first_name',
  LAST_NAME = 'last_name',
  EMAIL = 'email',
  PHONE = 'phone',
  CREATED_DATE = 'created_date',
}

export enum GROUP_ADMIN_SORT_FIELD {
  FIRST_NAME = 'first_name',
  LAST_NAME = 'last_name',
  EMAIL = 'email',
  PHONE = 'phone',
  CREATED_DATE = 'created_date',
}

export enum DELIVERY_METHOD {
  APP = 'app',
  EMAIL = 'email',
  TEXT = 'text',
}

export enum CALENDAR_VIEW {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
  YEAR = 'year',
}

export enum DAY_OF_WEEK {
  SUNDAY = 0,
  MONDAY = 1,
  TUESDAY = 2,
  WEDNESDAY = 3,
  THURSDAY = 4,
  FRIDAY = 5,
  SATURDAY = 6,
}

export enum CALENDAR_TYPE {
  EXTERNAL = 'external',
  LOCAL = 'local',
  MASS_TIMES = 'mass-times',
}

export enum MESSAGE_CHANNEL {
  APP_MESSAGE = 'App Message',
  APP_ANNOUNCEMENT = 'App Announcement',
  EMAIL = 'Email',
  TEXT_MESSAGE = 'Text Message',
  FACEBOOK = 'Facebook',
  // TODO: Twitter/X is temporarily disabled. This code may be deleted later.
  // X = 'X',
  WEBSITE = 'Website',
}

export enum MASS_TYPE {
  MASS = 'mass',
  ADORATION = 'adoration',
  CONFESSION = 'confession',
}

export enum MASS_EVENT_LANGUAGE {
  ENGLISH = 'english',
  SPANISH = 'spanish',
  LATIN = 'latin',
  VIETNAMESE = 'vietnamese',
}

export enum MASS_EVENT_CALENDAR_SCOPE {
  MASS_ONLY = 'mass-only',
  MASS_AND_LOCAL = 'mass-and-local',
}

export enum EVENT_FREQUENCY {
  DAILY = 'daily',
  EVERY_WEEKDAY = 'everyWeekday',
  WEEKLY = 'weekly',
  MONTHLY = 'monthly',
  YEARLY = 'yearly',
}

export enum EVENT_BY_DAY_PATTERN {
  MONDAY = 'MO',
  TUESDAY = 'TU',
  WEDNESDAY = 'WE',
  THURSDAY = 'TH',
  FRIDAY = 'FR',
  SATURDAY = 'SA',
  SUNDAY = 'SU',
}

export enum MANAGE_CALENDAR_VIEW {
  NEW = 'new',
  EDIT = 'edit',
}

export enum MESSAGE_STATUS {
  INBOX = 'inbox',
  SENT = 'sent',
  DELETED = 'deleted',
  SCHEDULED = 'scheduled',
  DRAFT = 'draft',
  TEMPLATE = 'template',
}

export enum MESSAGE_APPLICATION {
  MPA = 'mpa',
  MINISTRY = 'ministry',
}

export enum MEMBER_IMPORT_STATUS {
  NEW = 'new',
  PROCESSING = 'processing',
  IMPORT = 'import',
  DONE = 'done',
  ERROR = 'error',
}

export enum MOBILE_VIEW_STATE {
  MINI = 'mini',
  MONTH = 'month',
}

export enum DIRECTORY_TYPE {
  PARISH = 'parish',
  SCHOOL = 'school',
}

export enum MODAL_MODE {
  PREVIEW = 'preview',
  CREATE = 'create',
  EDIT = 'edit',
}

export enum MASS_TIME_VIEW {
  OVERVIEW = 'overview',
  LIST = 'list',
}
export enum CHURCH_PRODUCT {
  BRANDING_AND_DESIGN = 'branding_and_design',
  BULLETIN_RESOURCES = 'bulletin_resources',
  CAMINO = 'camino',
  DIOCESAN_PHOTOGRAPHY = 'diocesan_photography',
  DISCOVER_MASS = 'discover_mass',
  FORMS = 'forms',
  LIBRARY_OF_ART = 'library_of_art',
  MESSAGES = 'messages',
  MASS_INTENTIONS = 'mass_intentions',
  MY_PARISH_ADORATION = 'mp_adoration',
  MY_PARISH_FACILITIES = 'mp_facilities',
  MY_PARISH_MINISTRIES = 'mp_ministries',
  MPA = 'mpa',
  WEBSITES = 'websites',
}

export enum EVENT_OCCURRENCE_SCOPE {
  SINGLE = 'single',
  ALL_FUTURE = 'all_future',
}

export enum CALENDAR_EVENT_MODAL_KIND {
  CALENDAR = 'calendar',
  MASS = 'mass',
}

export enum WEB_PARTITION {
  MPA = 'MPA',
  FORMS = 'FORMS',
  MESSAGES = 'MESSAGES',
  MINISTRIES = 'MINISTRIES',
}

export enum USER_FORM_STATUS {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  DRAFT = 'draft',
  TEMPLATE = 'template',
}

export enum TEMPLATE_USE_MODE {
  AS_IS = 'as-is',
  WITH_EDITS = 'with-edits',
}

export enum USER_FORM_PROGRAM {
  MPA = 'mpa',
  MESSAGES = 'messages',
  CAMINO = 'camino',
  FORMS = 'forms',
}

export enum RECIPIENT_TYPE {
  GROUP = 'group',
  GROUP_MEMBER = 'groupMember',
  MEMBER = 'member',
  COMMUNITY_LIST = 'communityList',
  COMMUNITY_LIST_CARD = 'communityListCard',
}

export enum COMMUNITY_LIST_LOOKUP_SORT {
  NAME_ASC = 'name_asc',
  NAME_DESC = 'name_desc',
  NEWEST = 'newest',
  OLDEST = 'oldest',
}

export enum IMAGE_SOURCE {
  PARISH = 'parish',
  DIOCESAN = 'diocesan',
}

export enum MESSAGE_TEMPLATE_STATUS {
  DRAFT = 'draft',
  PUBLISHED = 'published',
}

export enum LIST_VIEW {
  OVERVIEW = 'overview',
  LIST = 'list',
}

export enum GRADIENT_ICON_VARIANT {
  BLUE = 'blue',
  GRAY = 'gray',
  GREEN = 'green',
  RED = 'red',
}

export enum SOCIAL_MEDIA_TYPE {
  INSTAGRAM = 'instagram',
  FACEBOOK = 'facebook',
  WHATSAPP = 'whatsapp',
  X = 'x',
  YOUTUBE = 'youtube',
  VIMEO = 'vimeo',
  PINTEREST = 'pinterest',
  FLICKR = 'flickr',
  WEBSITE = 'website',
}

export enum MESSAGE_REPLY_OPTION {
  IS_ALLOW = 'isAllow',
  IS_TO_GROUP_ADMINS_ONLY = 'isToGroupAdminsOnly',
  IS_TO_ADMINS_ONLY = 'isToAdminsOnly',
  IS_TO_ALL_MEMBERS = 'isToAllMembers',
  ADDITIONAL_EMAILS = 'additionalEmails',
}

export enum PAYMENT_METHOD_STATUS {
  ACTIVE = 'active',
  DELETED = 'deleted',
  EXPIRED = 'expired',
  INVALID = 'invalid',
}

export enum DELIVERY_REPORT_STATUS {
  NONE = 'none',
  SENT = 'sent',
  DELIVERED = 'delivered',
  OPENED = 'opened',
  FAILED = 'failed',
}

export enum FORM_RESULTS_TAB {
  SUMMARY = 'summary',
  TABLE = 'table',
  DETAILS = 'details',
}

export enum QUESTION_TYPE {
  TEXT = 'text',
  COMMENT = 'comment',
}

export enum CUSTOM_FIELD {
  CALENDAR_LITURGY = 'calendar-liturgy',
  CALENDAR_LOCATION = 'calendar-location',
  CALENDAR_LANGUAGE = 'calendar-language',
  DIRECTORY_PARISH_ROLE = 'directory-parish-role',
  DIRECTORY_SCHOOL_ROLE = 'directory-school-role',
}

export enum NOTIFICATION_TYPE {
  JOIN_REQUEST = 'join_request',
  MEMBER_JOINED_GROUP = 'member_joined_group',
  NEW_MEMBER = 'new_member',
  TEXT_CREDITS_LOW = 'text_credits_low',
  FACEBOOK_DISCONNECTED = 'facebook_disconnected',
}

export enum NOTIFICATION_STATUS {
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected',
}

export enum NOTIFICATION_FILTER {
  UNREAD = 'unread',
  ALL = 'all',
}

export enum CLUSTER_TYPE {
  ONE = 'one',
  MULTI = 'multi',
}

export enum SMS_BILLING_METHOD {
  CREDIT_CARD = 'credit_card',
  INVOICE = 'invoice',
  NOT_BILLED = 'not_billed',
}

export enum UNSAVED_CHANGES_MODAL_VARIANT {
  OVERLAY_GUARD = 'overlayGuard',
  SAVE_CHANGES = 'saveChanges',
}

export enum SCOPE_TYPE {
  CHURCH = 'church',
  GROUP = 'group',
  COMMUNITY_LIST = 'community_list',
}

export enum COMMUNITY_KIND {
  FAMILY = 'family',
  BUSINESS = 'business',
  MEMBER = 'member',
}

export enum COMMUNITY_SOURCE {
  MANUAL = 'manual',
  CAMINO = 'camino',
}

/** URL / tab slug for Community shell. Maps to kind + source. */
export enum COMMUNITY_TAB {
  BUSINESS = 'business',
  FAMILY = 'family',
  CAMINO_BUSINESS = 'camino-business',
  CAMINO_FAMILY = 'camino-family',
  MEMBER = 'member',
}

export enum COMMUNITY_CARD_SORT_FIELD {
  NAME = 'name',
  EMAIL = 'email',
  PHONE = 'phone',
}

export enum COMMUNITY_LIST_ADMIN_ACCESS_LEVEL {
  EDIT = 'edit',
  VIEW_ONLY = 'view_only',
}

export enum COMMUNITY_IMPORT_STATUS {
  NEW = 'new',
  PROCESSING = 'processing',
  IMPORT = 'import',
  DONE = 'done',
  ERROR = 'error',
}
